import { render, staticRenderFns } from "./platformWCS.vue?vue&type=template&id=23d6dd10&scoped=true&"
import script from "./platformWCS.vue?vue&type=script&lang=js&"
export * from "./platformWCS.vue?vue&type=script&lang=js&"
import style0 from "./platformWCS.vue?vue&type=style&index=0&id=23d6dd10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d6dd10",
  null
  
)

export default component.exports